module.exports = __webpack_public_path__ + "static/media/country_io.436beca4.webp";